import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-agricola-declaratoria-confirm-dialog',
  templateUrl: './agricola-declaratoria-confirm-dialog.component.html',
  styleUrls: ['./agricola-declaratoria-confirm-dialog.component.css'],
  standalone: false
})
export class AgricolaDeclaratoriaConfirmDialogComponent {

  accepted = false;

  constructor(private dialogRef: MatDialogRef<AgricolaDeclaratoriaConfirmDialogComponent>) {}

  close(cancel = false) {
    this.dialogRef.close(cancel ? false : this.accepted);
  }
}
